import { RECOMMENDATIONS, type Severity } from './NotificationBell';
import { Sparkline } from './Sparkline';

const SEV_LABEL: Record<Severity, string> = {
  critical: 'Critical',
  warning: 'Warning',
  info: 'Info',
};

const SAMPLE_SPARKS: Record<string, readonly number[]> = {
  'rec-1': [4.4, 4.3, 4.1, 3.9, 3.7, 3.5, 3.4, 3.3, 3.3, 3.2],
  'rec-2': [10, 14, 18, 22, 28, 32, 35, 35, 34, 35],
  'rec-3': [22, 24, 26, 28, 30, 31, 32, 32, 32, 32],
  'rec-4': [4, 5, 7, 10, 13, 15, 16, 17, 17, 18],
  'rec-5': [2, 4, 6, 9, 14, 18, 21, 23, 23, 23],
};

export function AiSidebar({ highlightId }: { highlightId?: string | null }) {
  return (
    <aside
      style={{
        width: 320,
        flexShrink: 0,
        position: 'sticky',
        top: 16,
        alignSelf: 'flex-start',
        display: 'flex',
        flexDirection: 'column',
        gap: 12,
      }}
      aria-label="KI-Empfehlungen"
    >
      <div style={{ display: 'inline-flex', alignItems: 'center', gap: 8, font: '600 14px/20px var(--font-display)', color: 'var(--fg-1)' }}>
        <span className="material-symbols-rounded" style={{ fontSize: 20, color: 'var(--brand-blue)', fontVariationSettings: '"FILL" 1' }}>
          auto_awesome
        </span>
        KI-Empfehlungen
      </div>
      {RECOMMENDATIONS.map((r) => {
        const spark = SAMPLE_SPARKS[r.id];
        const sparkColor =
          r.severity === 'critical' ? 'var(--brand-red)' :
          r.severity === 'warning' ? 'var(--brand-orange)' :
          'var(--brand-cyan)';
        const isHighlighted = highlightId === r.id;
        return (
          <div
            key={r.id}
            id={`rec-${r.id}`}
            className={`ai-rec-card sev-${r.severity}`}
            style={isHighlighted ? { boxShadow: '0 0 0 3px rgba(42,135,177,0.25)' } : undefined}
          >
            <span className={`ai-rec-tag sev-${r.severity}`}>{SEV_LABEL[r.severity]} · {r.time}</span>
            <span className="ai-rec-title">{r.title}</span>
            <span className="ai-rec-summary">{r.summary}</span>
            {spark && (
              <Sparkline data={spark} width={280} height={32} stroke={sparkColor} fill="transparent" />
            )}
            <span className="ai-rec-meta">{r.meta}</span>
            <button
              type="button"
              className="btn"
              style={{ alignSelf: 'flex-start', padding: '6px 12px', font: '500 12px/16px var(--font-body)' }}
            >
              Drilldown öffnen
              <span className="material-symbols-rounded">arrow_forward</span>
            </button>
          </div>
        );
      })}
    </aside>
  );
}
